import type {FC} from 'react';
import {CogScreenshotMap, ErrorMessage, GisContext} from 'talptech-gis-components';
import parseCogScreenshotQueryParameters from '../domain/useCases/parseCogScreenshotQueryParameters';
import 'talptech-gis-components/styles.css';

const CogScreenshotPage: FC = () => {
  try {
    const {cogUrl, bbox, legendTitle, lang, quantitativeLegend, categoricalLegend} = parseCogScreenshotQueryParameters(
      window.location.href,
    );

    return (
      <GisContext gisApiBaseUrl={'none'} crmApiBaseUrl={'none'} accessToken={'none'} language={lang}>
        <CogScreenshotMap
          cogUrl={cogUrl}
          bbox={bbox}
          legendTitle={legendTitle}
          quantitativeLegend={quantitativeLegend}
          categoricalLegend={categoricalLegend}
        />
      </GisContext>
    );
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown cause';
    return <ErrorMessage>Error: {message}</ErrorMessage>;
  }
};

export default CogScreenshotPage;
